








































































import { timeOption } from "@/views/OperationLog/config";
import { Component, Vue } from "vue-property-decorator";
import { statusList, PayTimes } from "../../config";
@Component({
  components: {},
})
export default class Home extends Vue {
  public info = {
    uid: "",
    order_num: "",
    bargain_id: "",
    status: "",
    s_time: "",
    e_time: "",
    export: 0,
    field: "",
  };
  public statusList = statusList;
  public options = timeOption;
  public payTimes = PayTimes;
  public changeTime(date) {
    this.info.s_time = date[0];
    this.info.e_time = date[1];
  }
  public searchClick() {
    const info = JSON.parse(JSON.stringify(this.info));
    this.$emit("searchClick", info);
  }
  public toExportExcel() {
    this.$emit("toExportExcel");
  }
}
